/* eslint-disable @typescript-eslint/triple-slash-reference */
// tslint:disable-next-line: no-reference
/// <reference path='../../images.d.ts'/>
import { ReactComponent as SadFace } from '../../assets/svg/face-sad.svg';
export default SadFace;
